module.exports = __webpack_public_path__ + "static/media/viewie-media-label.041061d9.svg";